import VueRouter, { RouteConfig } from 'vue-router'
// 由于音频播放之前需要用户进行页面交互，所以这里不使用懒加载
import Index from '../views/ai-teacher/MyAiTeacher.vue'
// const Index = () => import('../views/ai-teacher/MyAiTeacher.vue')

const indexRoute: RouteConfig = {
  path: '/my-ai-teacher',
  name: 'my_ai_teacher',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体育老师',
    ignoreLogin: true,
  },
}
export default [indexRoute]

export function navigateToAITeacher(router: VueRouter) {
  router.push({ name: indexRoute.name })
}
